import { Network, ArrowRight } from "lucide-react";
import { PARTNERS } from "@/lib/constants";
import { Link } from "react-router-dom";

export default function PartnersStrip() {
  return (
    <section className="py-24 bg-white" data-testid="partners-strip">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 mb-5">
              <Network className="w-5 h-5 text-[#E2718A]" />
              <span className="text-sm uppercase tracking-[0.2em] text-[#EA823A] font-semibold">Our trusted network</span>
            </div>
            <h2 className="font-display text-4xl lg:text-5xl text-[#1F2A2E] leading-tight mb-6">
              We don't work <span className="italic" style={{ color: "var(--navica-coral)" }}>alone</span>.
            </h2>
            <p className="text-lg text-[#4A595E] leading-relaxed mb-7">
              Great support coordination depends on great relationships. We work with a curated network of providers, advocates and clinicians across NSW. Chosen for quality, not commission.
            </p>
            <Link to="/contact" className="btn-outline" data-testid="partners-cta">
              Become a partner <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {PARTNERS.map((p, idx) => (
              <div
                key={p.category}
                className="bg-[#F1E4D5] border border-[#F0E5DE] rounded-3xl p-6 fade-up"
                style={{ animationDelay: `${idx * 0.06}s` }}
                data-testid={`partner-cat-${idx}`}
              >
                <h3 className="font-display text-lg text-[#1F2A2E] mb-3">{p.category}</h3>
                <ul className="space-y-1.5">
                  {p.items.map((item) => (
                    <li key={item} className="text-sm text-[#4A595E] flex gap-2">
                      <span className="text-[#EA823A] mt-1 shrink-0">·</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-[#F0E5DE] text-sm text-[#6B7A80] leading-relaxed">
          <span className="font-semibold text-[#284952]">Are you a provider, plan manager or community organisation?</span>{" "}
          We're always open to building relationships with values-aligned partners across NSW. Reach out via the <Link to="/contact" className="text-[#E2718A] underline">Connect</Link> page.
        </div>
      </div>
    </section>
  );
}
